<template>
	<div class="grid site" v-loading="loading || $store.state.guests.loading || $store.state.ombrelloni.loading">

		<Navbar :hotel="hotel" :guestList="guestList" :today="today" v-on:open="show" v-if="!$store.state.hotels.editsegments"></Navbar>

		<Dashboard v-if="open.dashboard" :result="result" :guestList="guestList" @datePick="changeDate" v-on:open="show" v-on:openmenu="openmenu"></Dashboard>
		<Seasons :hotel="hotel" v-if="open.seasons" v-on:open="show" v-on:openmenu="openmenu"></Seasons>
		<Settings :hotel="hotel" v-if="open.settings" v-on:open="show" v-on:openmenu="openmenu"></Settings>
		<Subusers :hotel="hotel" v-if="open.subusers" v-on:open="show" v-on:openmenu="openmenu"></Subusers>

		<Editgrid :hotel="hotel" v-on:open="show" v-if="open.editgrid" v-on:openmenu="openmenu"></Editgrid>

		<Broadcast v-on:open="show" v-if="open.broadcast" v-on:openmenu="openmenu"></Broadcast>

		<Billing :hotel="hotel" v-if="open.billing" v-on:openmenu="openmenu"></Billing>

	<el-drawer
		:visible.sync="open.menu"
		size="fit-content"
		custom-class="menu-drawer"
		>
		<Menu :hotel="hotel" v-on:open="show"></Menu>
	</el-drawer>

	<el-dialog
		title=""
		:visible.sync="open.addbeach"
		width="fit-content"
		:show-close="false"
		@close="open.addbeach = false, open.dashboard = true, checkOmbrelloni()"
		v-loading="$store.state.hotels.loading"
		destroy-on-close>
		<template slot="title">
			<div class="grid header">
				<div class="title" style="font-size: 20px;">Aggiungi spiaggia</div>
			</div>
		</template>
			<Addbeach @close="open.addbeach = false, open.dashboard = true, checkOmbrelloni()"></Addbeach>
	</el-dialog>

	<!-- <Errordialog></Errordialog> -->

	<Scanbutton v-if="$store.state.inapp" class="visible-xs"></Scanbutton>

	</div>
</template>

<script>
// @ is an alias to /src
import helper from '../Mixins/helper'
import Navbar from '@/components/Navbar.vue'
import Seasons from '@/components/Seasons.vue'
import Dashboard from '@/components/Dashboard.vue'
import Menu from '@/components/Menu.vue'
import Settings from '@/components/Settings.vue'
import Subusers from '@/components/Subusers.vue'
// import Newfacility from '@/components/Newfacility.vue'
import Editgrid from '@/components/Editgrid.vue'
import Broadcast from '@/components/Broadcast.vue'
import Addbeach from '@/components/micro/Addbeach.vue'
import Billing from '@/components/Billing.vue'
// import Errordialog from '@/components/micro/Errordialog.vue'
import Scanbutton from '@/components/micro/Scanbutton.vue'
import moment from 'moment'
import _ from 'lodash'
export default {
	name: 'Home',
	mixins: [helper],
	data () {
		return {
			loading: false,
			today: moment(),
			open: {
				dashboard: true,
				menu: false,
				seasons: false,
				settings: false,
				subusers: false,
				editgrid: false,
				broadcast: false,
				addbeach: false,
				billing: false
			}
			// jwt: localStorage.getItem('ombrelleria'),
		}
	},
	components: {
		Dashboard,
		Navbar,
		Seasons,
		Menu,
		Settings,
		Subusers,
		Editgrid,
		Broadcast,
		Addbeach,
		Billing,
		Scanbutton
		// Errordialog
		// Newfacility
	},
	methods: {
		checkOmbrelloni () {
			console.log('checkOmbrelloni after close ', this.$store.state.ombrelloni.ombrelloni.length, this.$store.state.hotels.hotels.length)
			if (this.$store.state.ombrelloni.ombrelloni.length === 0 && this.$store.state.hotels.hotels.length > 0) {
				console.warn('no ombrelloni')
				this.show('editgrid')
			}
		},
		changeDate (value) {
			this.today = value
		},
		show (section) {
			console.log(section)
			for (var sect in this.open) {
				this.open[sect] = false
			}
			this.open[section] = true
		},
		openmenu () {
			this.open.menu = !this.open.menu
		}
	},
	computed: {
		result () {
			console.log(this.$route.params.result)
			if (this.$route.params.result && this.$route.params.result !== undefined) {
	      console.log('good to go')
				return this.$route.params.result
			} else {			
				console.log('no result')
				return false
			}
		},
		hotel () {
			return this.$store.state.hotels.activehotel
		},
		guestList () {
			var self = this
			return _.filter(this.$store.state.guests.guests, function (g) {
				// console.log('home: guestList')
				return _.find(g.ombrelloni, function (d) {
					return moment(self.today).isBetween(moment(d.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(d.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]') && _.some(self.$store.state.ombrelloni.ombrelloni, {
						_id: d.ombrelloneid
					})
				})
				// return moment(self.today).isBetween(moment(g.stay.start, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(g.stay.end, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
			})
			// return _.filter(this.$store.state.ombrelloni.ombrelloni, function (g) {
			//   // console.log(g.guests)
			//   return _.find(g.guests, function (d) {
			//     return moment(self.today).isBetween(moment(d.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(d.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
			//   })
			//   // return moment(self.today).isBetween(moment(g.stay.start, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(g.stay.end, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
			// })
		}
	},
	created () {
	// console.log(this.$store.state.hotels.activehotel._id)
		if (this.$store.state.ombrelloni.ombrelloni.length === 0 && this.$store.state.hotels.hotels.length > 0) {
			console.warn('no ombrelloni')
			this.show('editgrid')
		}
	}
}
</script>
